document.addEventListener('DOMContentLoaded', function() {
  var accordionQuestions = document.querySelectorAll('.custom-accordion-question');
  accordionQuestions.forEach(function(button) {
    button.addEventListener('click', function() {
      var accordionItem = this.parentElement;
      accordionItem.classList.toggle('active');

      // Optionally, close other open items
      document.querySelectorAll('.custom-accordion-item').forEach(function(item) {
        if (item !== accordionItem) {
          item.classList.remove('active');
        }
      });
    });
  });
});
